import React, { useState } from 'react'
import { FormControl, InputLabel, Select, Input, MenuItem, Grid, Typography, FormHelperText } from '@material-ui/core'
import FolderIcon from '@material-ui/icons/Folder'
import { Project } from 'types/Project'
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer'

interface Props {
  classes: any,
  selected: null | Project,
  options: Project[],
  withNoneOption?: boolean,
  onNoneSelected?(): void,
  disabled?: boolean,
  onChange?(project: Project): void,
  helperText?: string,
}

const ProjectSelector = (props: Props) => {
  const {
    classes,
    selected = null,
    options = [],
    withNoneOption = false,
    onNoneSelected = () => {},
    disabled = false,
    onChange = () => {},
    helperText,
  } = props
  const onSelectHandler = async (projectId: string) => {
    const project = options.find((project) => project.id === projectId)
    if (project) {
      onChange(project)
    } else {
      if (projectId === NONE_PROJECT_ID) {
        onNoneSelected()
      }
    }
  }
  const NONE_PROJECT_ID = `__no-project-option__`
  const NONE_PROJECT_NAME = `Orders with no project`
  const noneOption: Project = {
    id: NONE_PROJECT_ID,
    name: NONE_PROJECT_NAME,
    purchaseOrderRequired: false,
  }
  const finalOptions = [
    noneOption,
    ...options,
  ]
  const renderSelectedText = (): string => {
    if (selected) {
      return selected.name
    } else {
      if (withNoneOption) {
        return NONE_PROJECT_NAME
      }
    }
    return ''
  }
  return (
    <FormControl fullWidth>
      <InputLabel htmlFor='project-selector' shrink>Project</InputLabel>
      <Select
        disabled={disabled}
        fullWidth
        displayEmpty={true}
        renderValue={(value) => (
          <React.Fragment>
            <FolderIcon className={classes.dropdownIcon} />
            { renderSelectedText() }
          </React.Fragment>
        )}
        value={selected !== null ? selected.id : '' }
        onChange={(e) => onSelectHandler(e.target.value as string)}
        input={<Input name='name' id='project-selector' />}
      >
        {finalOptions.map((project: Project) => {
          return (
            <MenuItem value={project.id} key={project.id} data-mf-replace-inner={MFSDR}>
              {project.name}
            </MenuItem>
          )
        })}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}

export default ProjectSelector
